import {
	CHECKOUT_FETCH_FULFILLED,
	CHECKOUT_FETCH_REJECTED,
	CHECKOUT_GET_DELIVERY_POINTS,
	CHECKOUT_GET_DELIVERY_POINTS_FULFILLED,
	CHECKOUT_SET_CHOSEN_CITY,
	CHECKOUT_SET_CHOSEN_DELIVERY_POINT,
	CHECKOUT_FETCH,
	CHECKOUT_SET_INTEGRITIES,
	SHOPCART_ADD,
	SHOPCART_EDIT,
	SHOPCART_FETCH,
	SHOPCART_REMOVE,
	SHOPCART_UPDATE
} from '../action-types';

const initialState = {
	deliveryMethods: [],
	integrities: [],
	paymentMethods: [],
	pendingActions: [],
	shipping: {},
	shopcartAvailable: undefined,
	specialParameters: {}
};
const pendingReducer = (state = [], {type}) => {
	const group = type.replace(/_FULFILLED|_PENDING|_REJECTED/, '');

	switch (group) {
		case CHECKOUT_FETCH:
		case CHECKOUT_GET_DELIVERY_POINTS:
		case SHOPCART_ADD:
		case SHOPCART_EDIT:
		case SHOPCART_FETCH:
		case SHOPCART_REMOVE:
		case SHOPCART_UPDATE: {
			return type.endsWith('_PENDING') ? state.concat(group) : state.filter(action => action !== group);
		}
		default: {
			return state;
		}
	}
};

const rootReducer = (state, action) => {
	switch (action.type) {
		case CHECKOUT_FETCH_FULFILLED: {
			return {
				...state,
				deliveryMethods: action.payload.deliveryMethods,
				paymentMethods: action.payload.paymentMethods,
				shopcartAvailable: action.payload.shopcartAvailable,
				specialParameters: action.payload.params
			};
		}
		case CHECKOUT_FETCH_REJECTED: {
			return {
				...initialState
			};
		}
		case CHECKOUT_SET_CHOSEN_CITY: {
			return {
				...state,
				shipping: {
					...state.shipping,
					chosenCity: action.payload
				}
			};
		}
		case CHECKOUT_SET_CHOSEN_DELIVERY_POINT: {
			return {
				...state,
				shipping: {
					...state.shipping,
					chosenDeliveryPoint: action.payload
				}
			};
		}
		case CHECKOUT_GET_DELIVERY_POINTS_FULFILLED: {
			return {
				...state,
				shipping: {
					...state.shipping,
					...action.payload
				}
			};
		}
		case CHECKOUT_SET_INTEGRITIES: {
			return {
				...state,
				integrities: action.payload.integrityConsent ? [...new Set([...state.integrities, ...action.payload.integrityNames])] : state.integrities.filter(integrity => !action.payload.integrityNames.includes(integrity))
			};
		}
		default: {
			return state;
		}
	}
};

export default (state = initialState, action) => ({
	...rootReducer(state, action),
	pendingActions: pendingReducer(state.pendingActions, action)
});
